// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CommerceNoticeTable_tableWrapper__V-spa"};